// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2pBDF","text":"PrivacyPolicy_text__1dnIi"};